// podtemat5_e8_zamkniete.js
// Dział 9 – zadania egzaminacyjne
// Podtemat 5 – E8 zamknięte

import * as BarChart from "./podtemat5_e8_zamkniete_types/E8SavingsBarChartClosedTask";
import * as CombinedMeans from "./podtemat5_e8_zamkniete_types/E8CombinedMeansClosedTask";
import * as LotteryProbability from "./podtemat5_e8_zamkniete_types/E8LotteryProbabilityClosedTask";
import * as PieChartTaskCount from "./podtemat5_e8_zamkniete_types/E8PieChartTaskCountClosedTask";
import * as ThreeNumbersMean from "./podtemat5_e8_zamkniete_types/E8ThreeNumbersMeanClosedTask";

export const registry = {
  E8SavingsBarChartClosedTask: BarChart,
  E8CombinedMeansClosedTask: CombinedMeans,
  E8LotteryProbabilityClosedTask: LotteryProbability,
  E8PieChartTaskCountClosedTask: PieChartTaskCount,
  E8ThreeNumbersMeanClosedTask: ThreeNumbersMean,
};

function pick(task) {
  const mod = registry[task.type];
  if (!mod) throw new Error("Unknown task type: " + task.type);
  return mod;
}

export function generateTasks(options = {}) {
  return [
    PieChartTaskCount.generateTask(options),
    BarChart.generateTask(options),
    CombinedMeans.generateTask(options),
    ThreeNumbersMean.generateTask(options),
    LotteryProbability.generateTask(options),
  ];
}

export function renderTask(task) {
  return pick(task).renderTask(task);
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return pick(task).renderInput(task, userAnswer, onChange, disabled);
}

export function checkAnswer(task, userAnswer) {
  return pick(task).checkAnswer(task, userAnswer);
}

export function renderAnswer(task) {
  return pick(task).renderAnswer(task);
}

export function renderExplanation(task) {
  return pick(task).renderExplanation(task);
}

export function renderUserAnswer(userAnswer, task) {
  const mod = registry[task.type];
  return typeof mod.renderUserAnswer === "function"
    ? mod.renderUserAnswer(userAnswer, task)
    : null;
}
